<template>
    <div class="t-profile">
        <div class="t-lk-container">
            <h1 class="t-lk-title t-lk-container-mobile">
                {{ $root.staticText.lk.profileTitle }}
                {{ '«' + profile.name + ' ' + profile.surname + '»' }}
            </h1>
            <div class="t-profile__container">
                <div class="t-profile-menu t-profile__box">
                    <router-link
                        class="t-profile-menu__item"
                        :class="{_active: item.link === $route.name}"
                        v-for="(item, index) in menu"
                        :key="'link' + index"
                        :to="{name: item.link}"
                        v-if="item.link !== 'lk-staff' || (item.link === 'lk-staff' && staff !== null)"
                    >
                        {{ item.name }}
                    </router-link>
                </div>
                <div class="t-profile-child">
                    <transition name="fadeChange">
                        <router-view></router-view>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import {mapGetters, mapMutations} from 'vuex';

    export default {
        name: "profile",
        data() {
            return {
                menu: [
                    {
                        name: this.$root.staticText.lk.security,
                        link: 'lk-security'
                    },
                    // {
                    //     name: this.$root.staticText.lk.subscription,
                    //     link: 'lk-subscription'
                    // },
                    {
                        name: this.$root.staticText.lk.notification,
                        link: 'lk-notification'
                    },
                    // {
                    //     name: this.$root.staticText.lk.staff,
                    //     link: 'lk-staff'
                    // },
                ],
                title: null,
                securityEmail: null,
                optionsRequest: [],
                subscriptions: [],
                notifications: [],
            }
        },
        computed: {
            ...mapGetters('lk', ['staff']),
            ...mapGetters('lk', ['profile']),
        },
        methods: {
            ...mapMutations('lk', ['setStaff']),

            setData(data) {
                this.title = data.title;
                this.securityEmail = data.securityEmail;
                this.optionsRequest = data.optionsRequest;
                // this.subscriptions = data.subscriptions;
                this.notifications = data.notifications;
                // this.setStaff(data.staff);
            },
        },
        beforeRouteEnter(to, from, next) {
            let url = process.env.NODE_ENV !== 'production' ? 'lk/profilePage.json' : 'lk/profilePage';
            Vue.http.get(url).then(
                (data) => {
                    if (data.data.staff === null) {
                        next('/403');
                    } else {
                        next(vm => vm.setData(data.data));
                    }
                },
                (data) => {
                    if (data.status === 403) {
                        next({name: 'E403'})
                    } else {
                        next({name: 'E404'})
                    }
                }
            );
        },
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/pages/lk/profile/index.vue